module.exports = __webpack_public_path__ + "img/p_bg2.e9ddffca.jpg";